import { Card } from '../ui/card';
import { Compass } from 'lucide-react';

export const BubbleInsightCard = ({ bubbleBreakSources, sources }) => {
  const entries = Object.entries(bubbleBreakSources || {})
    .map(([sourceId, count]) => ({
      source: sources.find((s) => s.id === parseInt(sourceId, 10)),
      count,
    }))
    .filter((e) => e.source)
    .sort((a, b) => b.count - a.count)
    .slice(0, 5);

  if (entries.length === 0) return null;

  const maxCount = entries[0].count;

  return (
    <Card className="p-6 sm:p-8 mb-8" data-testid="bubble-insight-card">
      <div className="flex items-center gap-3 mb-2">
        <Compass className="w-6 h-6 sm:w-8 sm:h-8 text-teal-600" />
        <h2 className="text-xl sm:text-2xl font-serif font-bold">Where You Break Your Bubble</h2>
      </div>
      <p className="text-sm text-gray-600 mb-5">
        The sources outside your usual reading habits that you open most often
      </p>

      <div className="space-y-3">
        {entries.map(({ source, count }) => (
          <div key={source.id} data-testid={`bubble-insight-source-${source.id}`}>
            <div className="flex justify-between text-sm mb-1">
              <span className="font-medium text-gray-800">{source.name}</span>
              <span className="text-gray-500">{count} {count === 1 ? 'time' : 'times'}</span>
            </div>
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                className="h-full bg-teal-500"
                style={{ width: `${(count / maxCount) * 100}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};
